import React from "react";
import img1 from '../../images/shareHome.png';
import downloadIcon from "../../images/downloadIcon.png";

const ShareSection = () => {
    return(
        <div className="share-section">
        <div className="share-section-box share-section-img">
          <img src={img1} alt="" />
        </div>
        <div className="share-section-box share-section-text">
          <h1 className="share-section-heading">
            Keep your clients up-to-date about their animals
          </h1>
          <div className="share-blue-line"></div>
          <p className="share-section-para">
            Something about patient handouts. Et harum quidem rerum facilis est et
            expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi
            optio cumque.
          </p>
          <div className="share-feature-box">
            <span className="share-feature-icon">
              <img src={downloadIcon} alt="" />
            </span>
            <div className="share-feature-text">
              <p className="share-feature-heading">Share, download and print</p>
              <p className="share-feature-para">
                Molestias excepturi sint occaecati cupiditate non provident,
                similique sunt.
              </p>
            </div>
          </div>
        </div>
      </div>
    )
}
export default ShareSection;